import cmpTruthDareBtn from "./modules/cmp-truth-dare-btn";
import cmpLogResultBtn from "./modules/cmp-log-results-btn";
import cmpDataContainer from "./modules/cmp-data-container";
import cmpCountdownTimer from "./modules/cmp-countdown-timer";
import cmpFlashScreen from "./modules/cmp-flash-screen";
import cmpQuestionContainer from "./modules/cmp-question-container";
import cmpCreateGameForm from "./modules/cmp-create-game-form";
import cmpPageHeader from "./modules/cmp-page-header";
import cmpPlayerNameContainer from "./modules/cmp-player-name-container";
import cmpSideMenu from "./modules/cmp-side-menu";
import cmpAdmin from "./modules/cmp-admin";
import cmpAppLogo from "./modules/cmp-app-logo";
import cmpScoresPage from "./modules/cmp-scores-page";
import cmpImageAttributionGallery from "./modules/cmp-image-attribution-gallery";
import cmpGameHistoryBtn from "./modules/cmp-game-history-btn";
import cmpLoginRegisterForgotForms from "./modules/cmp-login-register-forgot-form";

export const componentScripts = {
    cmpTruthDareBtn: cmpTruthDareBtn,
    cmpLogResultBtn: cmpLogResultBtn,
    cmpDataContainer: cmpDataContainer,
    cmpCountdownTimer: cmpCountdownTimer,
    cmpFlashScreen: cmpFlashScreen,
    cmpQuestionContainer: cmpQuestionContainer,
    cmpCreateGameForm: cmpCreateGameForm,
    cmpPageHeader: cmpPageHeader,
    cmpPlayerNameContainer: cmpPlayerNameContainer,
    cmpSideMenu: cmpSideMenu,
    cmpAdmin: cmpAdmin,
    cmpAppLogo: cmpAppLogo,
	cmpScoresPage: cmpScoresPage,
	cmpImageAttributionGallery: cmpImageAttributionGallery,
	cmpGameHistoryBtn: cmpGameHistoryBtn,
	cmpLoginRegisterForgotForms: cmpLoginRegisterForgotForms,
}
